import { useAudioStore } from '@/stores/audioStore';
import { STRINGS } from '@/strings/strings';
import { cn } from '@/lib/utils';
import { AudioPlayButton } from './AudioPlayButton';

/**
 * `-15 / Play-or-Pause 64px / 15+` control cluster. Text-only skip
 * buttons per Sönkes Figma (no Rewind/FastForward icons). Used by the
 * Inline-Player on the Story page and by Now-Playing Full-Screen — both
 * surfaces share the identical 64-px gold Play/Pause and the same skip
 * semantics (±15 s).
 */
interface AudioBigControlsProps {
  className?: string;
}

export function AudioBigControls({ className }: AudioBigControlsProps) {
  const isPlaying = useAudioStore((s) => s.isPlaying);
  const toggle = useAudioStore((s) => s.toggle);
  const skipBy = useAudioStore((s) => s.skipBy);

  const copy = STRINGS.storyOutput.page.audio;

  return (
    <div className={cn('flex items-center justify-center gap-4 pb-6', className)}>
      <button
        type="button"
        onClick={() => skipBy(-15)}
        aria-label={copy.ariaLabel.skipBack}
        className="flex size-[30px] items-center justify-end text-base font-medium leading-none text-dream-white md:text-xl"
      >
        -15
      </button>
      <AudioPlayButton
        size="big"
        isPlaying={isPlaying}
        onToggle={() => {
          void toggle();
        }}
        ariaLabelPlay={copy.ariaLabel.play}
        ariaLabelPause={copy.ariaLabel.pause}
      />
      <button
        type="button"
        onClick={() => skipBy(15)}
        aria-label={copy.ariaLabel.skipForward}
        className="flex size-[30px] items-center justify-start text-base font-medium leading-none text-dream-white md:text-xl"
      >
        15+
      </button>
    </div>
  );
}
